import type { TFunction } from "i18next";

/**
 * What stands in place of the control point when an archived analysis has none.
 *
 * Two different reasons, and the screen must not merge them: the tests were picked one by one, or the
 * sampling group exists but the lab program later deleted it from its codebook. Null when neither holds,
 * which is an analysis that had no request and so no group at all.
 */
export function missingPointLabel(
  t: TFunction,
  row: { testsChosenIndividually: boolean; legacyGroupId: number | null },
): string | null {
  if (row.testsChosenIndividually) return t("lab.individual", "testovi birani pojedinačno");
  if (row.legacyGroupId != null) {
    return t("lab.groupNotInCodebook", "grupa {{n}} (nema je u šifarniku laboratorije)", {
      n: row.legacyGroupId,
    });
  }
  return null;
}
